import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const TenantModule = new Module<Types.TenantFragment, Types.GetTenantsQueryVariables, Types.Tenants_Insert_Input>({
    sortKey: 'created_at',
})